
import { ConfigurationDefaultPreformattedResponseSampleType, ConfigurationPreformattedResponse } from '@/modules/configurationModule/detail/automation/preformatted/services/configuration-preformatted.dto'
import { CommonMostLikelyMorphologicCodeResponse } from '@/api/services/common/most-likely-morphologic-code/common-most-likely-morphologic-code.dto'
import { CommonProcedureResponse } from '@/api/services/common/procedure/common-procedure.dto'
import { CommonTopographicCodeResponse } from '@/api/services/common/topographic-code/common-topographic-code.dto'
import { Nullable } from '@/shared/types/app.types'
import { uniqueId } from 'lodash'

export interface LocalAutomationPreformattedModalState {
    uid: string
    id: Nullable<number>
    sampleTypes: Nullable<ConfigurationDefaultPreformattedResponseSampleType>
    preformatted: Nullable<ConfigurationPreformattedResponse>
    topographicCodes: Nullable<CommonTopographicCodeResponse>
    procedures: Nullable<CommonProcedureResponse>
    mostLikelyMorphologicCode: Nullable<CommonMostLikelyMorphologicCodeResponse>
}
export const initialLocalAutomationPreformattedModalState =
    (): LocalAutomationPreformattedModalState => ({
        uid: uniqueId(),
        id: null,
        sampleTypes: null,
        preformatted: null,
        topographicCodes: null,
        procedures: null,
        mostLikelyMorphologicCode: null
    })
